const FOOTER_LINKS = [
  { id: 'about', label: '它是什么' },
  { id: 'reliability', label: '靠谱吗' },
  { id: 'safety', label: '安全吗' },
  { id: 'virus', label: '有病毒吗' },
  { id: 'authenticity', label: '是不是假的' },
  { id: 'feedback', label: '用户口碑' },
  { id: 'risks', label: '风险提示' },
  { id: 'faq', label: '常见问题' },
];

export default function Footer() {
  const handleJump = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-film-line text-lg"></i>
              </span>
              <span className="font-heading font-bold text-background-50 text-lg">神马影院观察</span>
            </div>
            <p className="text-sm text-background-200 leading-relaxed">
              一个围绕第三方影视站点使用体验与风险梳理的信息页，帮助用户在使用前做出更清晰的判断。
            </p>
          </div>

          <div className="md:col-span-2">
            <h3 className="font-heading font-semibold text-background-50 text-sm mb-4">页面导航</h3>
            <div className="flex flex-wrap gap-x-5 gap-y-2">
              {FOOTER_LINKS.map((l) => (
                <button
                  key={l.id}
                  type="button"
                  onClick={() => handleJump(l.id)}
                  className="text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {l.label}
                </button>
              ))}
            </div>
            <div className="mt-6 pt-6 border-t border-secondary-800">
              <p className="text-xs text-background-300 leading-relaxed">
                免责声明：本页为信息整理与风险提示类内容，所涉描述基于第三方影视聚合站的普遍情况归纳，不针对任何特定站点的全部事实，也不构成法律或投资建议。是否使用相关服务请自行判断并承担相应风险。请遵守所在地的法律法规，支持正版内容。
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-300">© {new Date().getFullYear()} 神马影院观察 · 仅供信息参考</p>
          <p className="text-xs text-background-300">内容重在提醒理性判断，不作任何使用推荐</p>
        </div>
      </div>
    </footer>
  );
}